window.LayoutResolver = (function () {
    return {
        resolve: function (scope) {

            if (scope.isLayoutRightColumnVisible !== undefined && !scope.isLayoutRightColumnVisible) {
                LayoutRightColumn.hide();
            }
            else {
                LayoutRightColumn.show();
            }
        }
    };
}());